import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Alert, LogoMark } from "@printtat/ui";

const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:4000";

const initiateGoogleOAuth = () => {
  window.location.href = `${apiUrl}/auth/google/admin`;
};

export const SignInPage = () => {
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const state = location.state as { error?: string } | null;
    if (state?.error) setError(state.error);
  }, [location.state]);

  return (
    <div className="min-h-screen flex flex-col gap-y-6 items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm text-center flex items-center justify-center">
        <div>
          <Button onClick={initiateGoogleOAuth} variant="outline" className="">
            <LogoMark
              className="-ml-2 scale-125 shrink-0"
              style={{ width: "1.6rem", height: "1.4rem", opacity: 0.7 }}
            />{" "}
            <span className="ml-2 mr-1 font-mono text-xs! font-medium">Sign in with Google</span>
          </Button>
        </div>
      </div>

      {error && (
        <Alert variant="error" className="rounded-full! px-5! py-2! text-sm text-center">
          {error}
        </Alert>
      )}
    </div>
  );
};
